import { motion } from "framer-motion";
import { Award, Video, Users } from "lucide-react";

const TILES = [
  { span: "md:col-span-7 md:row-span-2", icon: Award, title: "BEF + Diplôme FFF" },
  { span: "md:col-span-5", icon: Video, title: "Analyste Vidéo Certifié Hudle" },
  { span: "md:col-span-5", icon: Users, title: "Fondateur Académie" },
];

export default function WhyTrust() {
  return (
    <section
      data-testid="why-trust-section"
      className="relative bg-[#050505] py-24 md:py-32 px-6 md:px-12 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.9] max-w-4xl"
        >
          UNE EXPERTISE
          <br />
          <span className="text-stroke">VALIDÉE</span>{" "}
          <span className="text-[#CCFF00]">SUR LE TERRAIN.</span>
        </motion.h2>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-4">
          {TILES.map((t, i) => {
            const Icon = t.icon;
            return (
              <motion.div
                key={t.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.6, delay: i * 0.07 }}
                className={`relative bg-[#0a0a0a] border border-white/10 p-8 hover:border-[#CCFF00]/50 hover:-translate-y-1 transition-all duration-300 group flex flex-col justify-between min-h-[180px] ${t.span}`}
                data-testid={`trust-tile-${i}`}
              >
                <Icon className="w-7 h-7 text-[#CCFF00]" strokeWidth={1.5} />
                <h3 className="mt-6 font-display text-3xl md:text-4xl leading-none text-white group-hover:text-[#CCFF00] transition-colors">
                  {t.title}
                </h3>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
